// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aDEyrj {
  border-radius: 4px;
  border: 1px solid var(--stroke-neutral-subtle);
  padding: var(--spacing-3);
  flex-grow: 1;
}

.BXzxMn {
  display: flex;
  gap: 0;
  align-items: stretch;
}

.jp2cBd {
  flex: 1;
  padding-right: var(--spacing-3);
  min-width: 0;
  overflow: hidden;
}

.HSzj1l {
  flex-shrink: 0;
  padding-left: var(--spacing-3);
}

.OMZZnt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-2);
}

.HZoKhx {
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0;
}

.MfXZeL {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  margin-bottom: var(--spacing-1);
}

.HJwGeI {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.HURanX {
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 4px;
  padding: 14px 8px;
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 20px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}

.EXL4j9 {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
  flex-shrink: 0;
}

.E5AtCx {
  width: 16px;
  height: 16px;
}

.sbCsMk {
  padding: 0;
}

.qZIHH3 {
  margin-top: var(--spacing-2);
  align-self: center;
}

.jSgNBS.BXzxMn {
  align-items: center;
}

.jSgNBS .jp2cBd {
  padding-right: 0;
}

.jSgNBS .HZoKhx {
  margin-bottom: 4px;
}

.jSgNBS .MfXZeL {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .aDEyrj {
    padding: 16px;
  }

  .HJwGeI {
    flex-direction: column;
    align-items: stretch;
  }

  .HURanX {
    white-space: normal;
    word-break: break-all;
    text-overflow: clip;
    overflow: visible;
  }

  .HZoKhx {
    font-size: 16px;
  }

  .MfXZeL {
    font-size: 13px;
  }

  .EXL4j9 {
    width: 100%;
    min-width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/RechargePaymentBankSlipPage/components/RechargePaymentBankSlipCode/RechargePaymentBankSlipCode.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".container {\n  border-radius: 4px;\n  border: 1px solid var(--stroke-neutral-subtle);\n  padding: var(--spacing-3);\n  flex-grow: 1;\n}\n\n.bankSlipSection {\n  display: flex;\n  gap: 0;\n  align-items: stretch;\n}\n\n.leftSection {\n  flex: 1;\n  padding-right: var(--spacing-3);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.rightSection {\n  flex-shrink: 0;\n  padding-left: var(--spacing-3);\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-2);\n}\n\n.title {\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0;\n}\n\n.description {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  margin-bottom: var(--spacing-1);\n}\n\n.codeContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  min-width: 0;\n  width: 100%;\n}\n\n.codeText {\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 4px;\n  padding: 14px 8px;\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 20px;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.downloadButton {\n  padding: 0;\n}\n\n.generateButton {\n  margin-top: var(--spacing-2);\n  align-self: center;\n}\n\n.withoutPaymentCode.bankSlipSection {\n  align-items: center;\n}\n\n.withoutPaymentCode .leftSection {\n  padding-right: 0;\n}\n\n.withoutPaymentCode .title {\n  margin-bottom: 4px;\n}\n\n.withoutPaymentCode .description {\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .codeContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .codeText {\n    white-space: normal;\n    word-break: break-all;\n    text-overflow: clip;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .description {\n    font-size: 13px;\n  }\n\n  .copyButton {\n    width: 100%;\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `aDEyrj`,
	"bankSlipSection": `BXzxMn`,
	"leftSection": `jp2cBd`,
	"rightSection": `HSzj1l`,
	"titleContainer": `OMZZnt`,
	"title": `HZoKhx`,
	"description": `MfXZeL`,
	"codeContainer": `HJwGeI`,
	"codeText": `HURanX`,
	"copyButton": `EXL4j9`,
	"copyIcon": `E5AtCx`,
	"downloadButton": `sbCsMk`,
	"generateButton": `qZIHH3`,
	"withoutPaymentCode": `jSgNBS`
};
module.exports = ___CSS_LOADER_EXPORT___;
